document.addEventListener("DOMContentLoaded", () => {
  let wishlist =
    JSON.parse(localStorage.getItem("bricks-and-blocks__wishlist")) || [];

  const customerDataElement = document.getElementById("customer-data");
  const productDataElement = document.getElementById("product-data");
  const loadingMessage = document.getElementById("wishlist-loading");

  // const wishlistIcons = document.querySelectorAll(`[id^="wishlist-icon"]`);
  const cartBtns = document.querySelectorAll(`[id^="cart-wishlist"]`);
  const wishlistHandlesElement = document.getElementById("wishlist-handles");
  const wishlistHeaderElement = document.getElementById("wishlist-headers");
  const alertBanner = document.getElementById("alert-banner");
  const removeLinks = document.querySelectorAll(".js-remove-item");

  console.log(window.location.pathname, "path");
  if (window.location.pathname === "/cart") {
    cartBtns.forEach((btn) => {
      let item = btn.getAttribute("data-item");
      item = JSON.parse(item);
      btn.addEventListener("click", (e) => {
        if (!customerData) {
          // Prevent further actions
          showNotAllowedMessage();
        } else {
          e.preventDefault();

          const product = {
            product_id: item.product_id,
            product_handle: item.handle,
            proimage: item.image,
            protitle: item.title,
            vname: item.product_title,
            proprice: item.price,
            checked: true,
          };

          // Add item to the cart logic
          addItem(product);

          // Find the remove link associated with this item
          const removeLink = document.querySelector(
            `a[href*='id=${item.key}']`
          );

          // Check if the removeLink is found
          if (removeLink) {
            // removeFromCart(item.key);
            // Simulate the click on the remove link
            removeLink.click();
          } else {
            console.error("Remove link not found for item key:", item.key);
          }

          // Optionally, you can remove the item directly using `removeFromCart(item.key)`
          // enableOtherButtons()
        }
      });
    });
  }

  function enableOtherButtons() {
    cartBtns.forEach((btn) => {
      btn.disabled = false; // Ensure buttons are not disabled
      btn.classList.remove("disabled"); // Remove any disabled CSS class if present
    });
  }

  if (!customerDataElement || !productDataElement) {
    console.warn("Required script tags not found");
    return;
  }

  const customerData = JSON.parse(customerDataElement.textContent);

  if (!customerData) {
    handleNotLoggedIn(loadingMessage);
    localStorage.removeItem("bricks-and-blocks__wishlist");
  } else {
    loadZooomyData(customerData.customer_id);
  }
  if (customerData && wishlist.length === 0) {
    emptyWishlist(loadingMessage);
    if (wishlistHeaderElement) {
      wishlistHeaderElement.style.display = "none";
    }
  }

  function emptyWishlist(loadingMessage) {
    if (loadingMessage) {
      loadingMessage.innerHTML = `
      <div class="x-flex x-flex-col logged-in-alert x-justify-center x-items-center">
        <div class="alert-text">
          <p>Your Wishlist is empty</p>
        </div>
        <div class="x-flex x-flex-col x-gap-4 alert-btns">
          <a href="/collections/all" class="btn btn-1">Shop Now</a>
        </div>
      </div>
    `;
    }
    if (wishlistHandlesElement) {
      wishlistHandlesElement.style.display = "none";
      wishlistHeaderElement.style.display = "none";
    }
    console.warn("Wishlist is empty");
  }

  function removeItem(productId) {
    wishlist = wishlist.filter((item) => item.product_id !== productId);

    const script = document.createElement("script");
    script.src = `https://zooomyapps.com/wishlist/RemoveFromWishlist.php?shop=bricks-and-blocks-sa.myshopify.com&productid=${productId}&customerid=${customerData.customer_id}&wishcount=${wishlist.length}`;
    document.head.appendChild(script);

    if (wishlist.length === 0) {
      if (loadingMessage) {
        loadingMessage.style.display = "block";
        emptyWishlist(loadingMessage);
      }
    }

    updateWishlistStorage();
  }

  function addItem(product) {
    console.log(product);
    console.log(customerData);
    wishlist.push(product);
    updateWishlistStorage();

    const scriptTag = document.createElement("script");
    scriptTag.src = `https://zooomyapps.com/wishlist/wishlist-check1.php?shop=bricks-and-blocks-sa.myshopify.com&productid=${
      product.product_id
    }&customerid=${
      customerData.customer_id || "guest"
    }&checked=true&wishcount=${
      wishlist.length
    }&variantname=${new Date()}&totalv=2`;
    document.head.appendChild(scriptTag);
  }

  function updateWishlistStorage() {
    localStorage.setItem(
      "bricks-and-blocks__wishlist",
      JSON.stringify(wishlist)
    );
    if (window.location.pathname === "/pages/wishlist") {
      fetchProductData();
    }
  }

  function showNotAllowedMessage() {
    // Check if the alert already exists
    const existingAlert = document.getElementById("not-allowed-alert");
    if (existingAlert) return;

    // Create the overlay
    const overlay = document.createElement("div");
    overlay.id = "alert-overlay";
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    overlay.style.zIndex = "9998";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";

    // Create the alert element
    const alertElement = document.createElement("div");
    alertElement.id = "not-allowed-alert";
    alertElement.style.position = "relative";
    alertElement.style.display = "flex";
    alertElement.style.flexDirection = "column";
    alertElement.style.gap = "10px";
    alertElement.style.backgroundColor = "#fff";
    alertElement.style.padding = "20px";
    alertElement.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
    alertElement.style.borderRadius = "8px";
    alertElement.style.textAlign = "center";
    alertElement.style.maxWidth = "90%"; // Adjust for smaller screens
    alertElement.style.width = "500px";
    alertElement.style.height = "200px";
    alertElement.style.justifyContent = "center";
    alertElement.style.zIndex = "9999";
    alertElement.style.transition = "opacity 0.5s ease";
    alertElement.style.opacity = "0"; // Start hidden

    // Add the close (X) button
    const closeButton = document.createElement("span");
    closeButton.innerHTML = "&times;";
    closeButton.style.position = "absolute";
    closeButton.style.top = "10px";
    closeButton.style.right = "10px";
    closeButton.style.cursor = "pointer";
    closeButton.style.fontSize = "20px";
    closeButton.style.fontWeight = "bold";
    closeButton.style.color = "#333";

    // Close the alert when the "X" is clicked
    closeButton.addEventListener("click", closeAlert);

    alertElement.id = "not-allowed-alert";
    alertElement.style.position = "fixed";
    alertElement.style.display = "flex";
    alertElement.style.flexDirection = "column";
    alertElement.style.gap = "10px";
    alertElement.style.top = "50%";
    alertElement.style.left = "50%";
    alertElement.style.transform = "translate(-50%, -50%)";
    alertElement.style.zIndex = "9999";
    alertElement.style.backgroundColor = "#fff";
    alertElement.style.padding = "20px";
    alertElement.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
    alertElement.style.borderRadius = "8px";
    alertElement.style.textAlign = "center";
    alertElement.style.maxWidth = "90%"; // Adjust for smaller screens
    alertElement.style.width = "500px";
    alertElement.style.transition = "opacity 0.3s ease";
    alertElement.style.opacity = "0"; // Start hidden
    alertElement.style.height = "200px";
    alertElement.style.justifyContent = "center";

    // The content inside the alert box
    alertElement.innerHTML = `
      <p>You must be logged in to use the wishlist feature.</p>
      <div class="x-flex x-flex-col x-gap-[10px] x-items-center">
        <a href="/account/login" class="btn btn-1">Login</a>
        <a href="/account/register" class="btn btn-2">Sign up</a>
      </div>
    `;

    // Append the close button to the alert element
    alertElement.appendChild(closeButton);

    // Append the alert element and the overlay to the body
    document.body.appendChild(overlay);
    document.body.appendChild(alertElement);

    // Make the alert visible
    setTimeout(() => {
      alertElement.style.opacity = "1";
    }, 10);

    // Close the alert when clicking outside the box
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        closeAlert();
      }
    });

    // Function to close the alert
    function closeAlert() {
      alertElement.style.opacity = "0";
      setTimeout(() => {
        alertElement.remove();
        overlay.remove();
      }, 500); // Allow time for fade-out effect
    }
  }

  function loadZooomyData(customerId) {
    const ZooomyDataFun = (B, J, M) => {
      B.ajax({
        url: "https://zooomyapps.com/wishlist/ListWishlist.php",
        data: { shop: J, customerid: M },
        dataType: "jsonp",
        jsonp: "ZooomyGetDataPage",
        async: "true",
        success: (n) => {
          wishlist = extractProductInfo(n);
          updateWishlistStorage();
        },
        error: (t) => console.log(t, "t"),
      });
    };

    if (typeof window.jQuery === "undefined") {
      loadJQuery(() =>
        ZooomyDataFun(
          window.jQuery.noConflict(true),
          "bricks-and-blocks-sa.myshopify.com",
          customerId
        )
      );
    } else {
      ZooomyDataFun(
        window.jQuery,
        "bricks-and-blocks-sa.myshopify.com",
        customerId
      );
    }
  }

  function loadJQuery(callback) {
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js";
    script.type = "text/javascript";
    script.onload = callback;
    document.head.appendChild(script);
  }

  function extractProductInfo(obj) {
    return Array.from({ length: obj.records }).map((_, i) => ({
      product_id: obj.product_id[i],
      product_handle: obj.product_handle[i],
      proimage: obj.product_img[i],
      protitle: obj.product_name[i],
      vname: obj.variant_name[i],
      proprice: obj.product_price[i],
      checked: true,
    }));
  }

  function fetchProductData() {
    const productHandles = wishlist.map((item) => item.product_handle);
    let fetchedProductsCount = 0;

    // Clear the previous wishlist before rendering the new one
    if (wishlistHandlesElement) {
      wishlistHandlesElement.innerHTML = "";
    }

    productHandles.forEach((handle) => {
      fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const priceHTML = `<div class="product-price x-font-light">R ${(
            product.price / 100
          ).toFixed(2)}</div>`;

          if (wishlistHandlesElement) {
            wishlistHandlesElement.innerHTML += `
              <div class="wishlist-product x-items-center x-grid x-mx-auto x-my-0" data-handle="${product.handle}">
                <a href="/products/${product.handle}" class="product-info x-gap-[20px] sm:x-gap-[40px] x-border-left-none md:x-border-left x-max-h-[135px]">
                  <img width="200" height="200" src="${product.images[0]}" class="wishlist-img x-object-contain x-mix-blend-multiply"/>
                  <div class="product-title md:x-pr-[30px] x-flex x-flex-col">${product.title}
                    <div class="product-price-container-sm">
                      ${priceHTML}
                    </div>
                  </div>
                </a>
                <div class="product-price-container-lg">
                  ${priceHTML}
                </div>
                <div class="product-actions">
                  ${
                    product.available
                      ? `
                        <button class="btn btn-1 add-to-cart-btn" js-quick-add data-handle="${product.handle}" data-id="${product.id}" data-variant-id="${product.variants[0].id}">Add to Cart</button>
                        <button class="btn btn-2 remove-btn" data-id="${product.id}">Remove</button>
                      `
                      : `
                        <button class="btn btn-1 btn-out-of-stock">Out of Stock</button>
                        <button class="btn btn-2 remove-btn" data-id="${product.id}">Remove</button>
                      `
                  }
                </div>
              </div>
            `;
                

            fetchedProductsCount++;

            if (fetchedProductsCount === wishlist.length) {
              loadingMessage.style.display = "none";
              wishlistHandlesElement.style.display = "grid";
            }

            const addToCartButtons =
              document.querySelectorAll(".add-to-cart-btn");
            addToCartButtons.forEach((button) => {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                const productId = this.getAttribute("data-id");
                const productVariantId = this.getAttribute("data-variant-id");
                // Trigger the quick-add functionality using Liquid AJAX API
                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: productVariantId,
                    quantity: 1,
                  }),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    alertBanner.classList.remove("x-hidden");
                    alertBanner.classList.add("x-flex");

                    alertBanner.innerHTML = `
              Product has been successfully added to cart!
              `;

                    // Hide the alert banner after 3 seconds
                    setTimeout(() => {
                      alertBanner.classList.add("x-hidden");
                    }, 3000);

                    removeItem(productId, product);
                    // Optionally refresh or update the cart UI
                  })
                  .catch((error) => {
                    console.error("Error adding product to cart:", error);
                  });
              });
            });

            const removeButtons = document.querySelectorAll(".remove-btn");
            removeButtons.forEach((button) => {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                const productId = this.getAttribute("data-id");
                removeItem(productId, product);
              });
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching product data:", error);
        });
    });
  }

  function removeFromCart(lineItemId) {
    console.log(lineItemId);
    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: lineItemId,
        quantity: 0, // Set quantity to 0 to remove the item
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        const alertBanner = document.getElementById("alert-banner");
        alertBanner.classList.remove("x-hidden");
        alertBanner.classList.add("x-flex");
        alertBanner.innerHTML = `
        Item has been removed from the cart.
      `;

        // Hide the alert after 3 seconds
        setTimeout(() => {
          alertBanner.classList.add("x-hidden");
        }, 3000);
      })
      .catch((error) => {
        console.error("Error removing item from cart:", error);
      });
  }

  function handleNotLoggedIn(loadingMessage) {
    window.localStorage.removeItem("bricks-and-blocks__wishlist");

    if (loadingMessage) {
      loadingMessage.innerHTML = `
        <div class="x-flex x-flex-col logged-in-alert x-justify-center x-items-center">
          <div class="alert-text">
            <p>You need an account to use our wishlist function. Create an account now and never lose track of your favourite items.</p>
          </div>
          <div class="x-flex x-flex-col x-gap-4 alert-btns">
            <a href="/account/login" class="btn btn-1">Login</a>
            <a href="/account/register" class="btn btn-2">Sign up</a>
          </div>
        </div>
      `;
    }

    if (wishlistHandlesElement) {
      wishlistHandlesElement.style.display = "none";
      wishlistHeaderElement.style.display = "none";
    }

    console.warn("Wishlist requires a logged-in customer");
  }
});
